// extracted by mini-css-extract-plugin
module.exports = {"snsBlock__list":"SnsBlock_snsBlock__list__zE52Q"};